import React from 'react';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.bsmith993.standlogic';

export const PLAY_TRADEMARK_NOTICE = 'Google Play and the Google Play logo are trademarks of Google LLC.';

function GooglePlayBadge() {
  return (
    <a
      href={PLAY_STORE_URL}
      className="play-badge-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/google-play-badge.png" alt="Get it on Google Play" className="play-badge" />
    </a>
  );
}

export default GooglePlayBadge;
